// extracted by mini-css-extract-plugin
export default {"RequiresOnboardingState":"styles_RequiresOnboardingState__Q-SKJ","sticky":"styles_sticky__mV00f","body":"styles_body__eQj8v","content":"styles_content__JOlHo"};